import apiInstance from "../api";
import endPoints from "../endpoints";
import { delay } from "../helpers";
import fileApiInstance from "../fileApi";

export const SaveFeeCalculationDetails = (payload) => {
  return apiInstance().post(
    `${endPoints.fee.saveFeeCalculationDetails}`,
    payload
  );
};

export const getFeeDetailsBySearchCriteria = (payload) => {
  return apiInstance().post(
    `${endPoints.fee.getFeeDetailsBySearchCriteria}`,
    payload
  );
};

export const saveBasicFeeDetails = (payload) => {
  return apiInstance().post(`${endPoints.fee.saveBasicFeeDetails}`, payload);
};

export const addFeeClassification = (payload) => {
  return apiInstance().post(`${endPoints.fee.addFeeClassification}`, payload);
};

export const getFeeDetailsById = (feeId) => {
  return apiInstance().get(`${endPoints.fee.getFeeDetailsById}/${feeId}`);
};

export const getFeeCalculationDetailsById = (feeId) => {
  return apiInstance().get(
    `${endPoints.fee.getFeeCalculationDetailsById}/${feeId}`
  );
};

export const getFeeTransactionById = (feeTransactionId) => {
  return apiInstance().get(
    `${endPoints.fee.getFeeTransactionById}/${feeTransactionId}`
  );
};

export const cancelTradeByFeeId = (feeId) => {
  return apiInstance().get(`${endPoints.fee.cancelTradeByFeeId}/${feeId}`);
};

export const getFeeClassifications = () => {
  return apiInstance().get(`${endPoints.fee.getFeeClassifications}`);
};

export const ValidateCreateSpecificationSlider = (payload) => {
  return apiInstance().post(
    `${endPoints.fee.validateCreateSpecificationSlider}`,
    payload
  );
};

export const addSpecificationDetails = (payload) => {
  return apiInstance().post(
    `${endPoints.fee.addSpecificationDetails}`,
    payload
  );
};

export const getFeeRunListingDetailsBySearchCriteria = (payload) => {
  return apiInstance().post(
    `${endPoints.fee.getFeeRunListingDetailsBySearchCriteria}`,
    payload
  );
};
export const getParticipantFeeRunDetailsList = (planId) => {
  return apiInstance().get(
    `${endPoints.fee.getParticipantFeeRunDetailsList}/${planId}`
  );
};

export const downloadFeeTransactionListingReport = (payload) => {
  return fileApiInstance().post(
    endPoints.fee.downloadFeeTransactionListingReport,
    payload
  );
};

export const downloadFeeTransactionSummaryReport = (payload) => {
  return fileApiInstance().post(
    endPoints.fee.downloadFeeTransactionSummaryReport,
    payload
  );
};

export const getFeeSpecificationBasedOnSearchCriteria = (payload) => {
  return apiInstance().post(
    `${endPoints.fee.getFeeSpecificationBasedOnSearchCriteria}`,
    payload
  );
};
export const getFeeSpecificationDetailsById = (payload) => {
  return apiInstance().get(
    `${endPoints.fee.getFeeSpecificationDetailsById}/${payload}`
  );
};
export const GetFeeApplicableTo = (Id) => {
  return apiInstance().get(`${endPoints.fee.getFeeApplicableTo}/${Id}`);
};
export const AddFeeApplicableTo = (payload) => {
  return apiInstance().post(`${endPoints.fee.addFeeApplicableTo}`, payload);
};

export const GetFeeSchedule = (Id) => {
  return apiInstance().get(`${endPoints.fee.getFeeSchedule}/${Id}`);
};
export const AddFeeSchedule = (payload) => {
  return apiInstance().post(`${endPoints.fee.addFeeSchedule}`, payload);
};

export const getSourceAndInvestmentList = (payload) => {
  return apiInstance().get(
    `${endPoints.fee.getSourceAndInvestmentList}/${payload}`
  );
};
export const getPlanListBasedOnFilter = (payload) => {
  return apiInstance().post(
    `${endPoints.fee.getPlanListBasedOnFilter}`,
    payload
  );
};

export const getPlanGroupsForFee = (investmentId) => {
  return apiInstance().get(
    `${endPoints.fee.getPlanGroupsForFee}/${investmentId}`
  );
};

export const getInvestmentForFee = (investmentId) => {
  return apiInstance().get(
    `${endPoints.fee.getInvestmentForFee}/${investmentId}`
  );
};
export const getPlanLevelFeeCollectedDetailsAfterTrade = (payload) => {
  return apiInstance().post(
    `${endPoints.fee.getPlanLevelFeeCollectedDetailsAfterTrade}`,
    payload
  );
};
// export const saveSummaryDetails = (payload) => {
//   return apiInstance().post(
//     `${endPoints.fee.saveSummaryDetails}`,
//     payload
//   );
// };

export const saveSummaryDetails = (id) => {
  return apiInstance().get(`${endPoints.fee.saveSummaryDetails}/${id}`);
};

export const getFeeSummaryDetailsById = (payload) => {
  return apiInstance().get(
    `${endPoints.fee.getFeeSummaryDetailsById}/${payload}`
  );
};
